export default {
      id: "flex-alignContent-space-around-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignContent-space-around-usage",
      toString: function () {
        return this.url;
      }
    }